export const mainOptionsList = [
    {
        type : "number",
        dataInputName : "height",
        optionName : "Höhe:"
    }
];

export const lidOptionsList = [
    {
        type : "number",
        dataInputName : "length",
        optionName : "Länge:"
    },
    {
        type : "number",
        dataInputName : "height",
        optionName : "Höhe:"
    }
];


// WEBPACK FOOTER //
// ./src/containers/steps/BuildSteps/PlanArea/OptionList.js